import {
  Box,
  HStack,
  Heading,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { AiFillCheckCircle } from "react-icons/ai";

export default function Goals() {
  return (
    <Stack
      gap={2}
      my={10}
      px={{ base: 2, md: 5, lg: 10 }}
      py={10}
      border="1px solid #c5c5c5"
      borderRadius="5px"
    >
      <Heading fontSize={{ base: "18px", md: "24px" }} fontWeight={"semibold"}>
        Goals To Become A Level One Seller
      </Heading>
      <SimpleGrid columns={{ base: 1, lg: 2, "2xl": 3 }} gap={10} py={5}>
        {data.map((item) => {
          return (
            <Stack gap={1} w={"90%"} key={item.title}>
              <HStack
                fontSize={{ base: "14px", md: "18px" }}
                fontWeight="semibold"
                gap={1}
                color="brand.500"
              >
                <AiFillCheckCircle
                  color={item.complete ? "#008DDB" : "#C5C5C5"}
                  size="24px"
                />
                <Text color="black">{item.title}</Text>
              </HStack>
              <Text fontWeight="medium" fontSize={{ base: "14px", md: "16px" }}>
                {item.description}
              </Text>
              <HStack>
                <Box
                  p={2}
                  w="full"
                  rounded="lg"
                  bg={item.complete ? "brand.500" : "#c5c5c5"}
                />
                <Text>{item.complete ? "100%" : "0%"}</Text>
              </HStack>
            </Stack>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
}
const data = [
  {
    title: "Inbox response time",
    description:
      "Respond to 90% of the inquiries your received in the last 60 days",
    complete: true,
  },
  {
    title: "Order completion",
    description:
      "Respond to 90% of the inquiries your received in the last 60 days",
    complete: true,
  },
  {
    title: "On-time delivery",
    description:
      "Respond to 90% of the inquiries your received in the last 60 days",
    complete: true,
  },
  {
    title: "Rating",
    description:
      "Respond to 90% of the inquiries your received in the last 60 days",
    complete: false,
  },
  {
    title: "Selling seniority",
    description: "Complete at least 60 days as a seller",
    complete: true,
  },
  {
    title: "Orders",
    description: "Receive and complete at least 10 orders (all time)",
    complete: false,
  },
  {
    title: "Sales",
    description: "Earn at least $400 from completed orders (all time)",
    complete: false,
  },
  {
    title: "Days without warnings",
    description:
      "Avoid receiving warnings for TOS violations over the course of 30 days",
    complete: false,
  },
];
